var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBullet = function SvgIconBullet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon-bullet_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-bullet_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5E6574",
    d: "M13.333 8.333c.236 0 .434-.08.594-.24a.803.803 0 0 0 .24-.593.806.806 0 0 0-.24-.594.806.806 0 0 0-.594-.24h-2.5a.806.806 0 0 0-.593.24.806.806 0 0 0-.24.594c0 .236.08.434.24.594.16.16.357.24.593.24h2.5Zm0 5c.236 0 .434-.08.594-.24a.803.803 0 0 0 .24-.593.807.807 0 0 0-.24-.594.806.806 0 0 0-.594-.24h-2.5a.806.806 0 0 0-.593.24.807.807 0 0 0-.24.594c0 .236.08.434.24.594.16.16.357.24.593.24h2.5ZM7.5 9.167c.458 0 .85-.164 1.177-.49.326-.326.49-.719.49-1.177 0-.458-.164-.85-.49-1.177a1.605 1.605 0 0 0-1.177-.49c-.458 0-.85.164-1.177.49-.326.326-.49.719-.49 1.177 0 .458.164.85.49 1.177.326.326.719.49 1.177.49Zm0 5c.458 0 .85-.163 1.177-.49.326-.326.49-.719.49-1.177 0-.458-.164-.85-.49-1.177a1.605 1.605 0 0 0-1.177-.49c-.458 0-.85.163-1.177.49-.326.326-.49.719-.49 1.177 0 .458.164.85.49 1.177.326.327.719.49 1.177.49ZM4.167 17.5c-.459 0-.851-.163-1.177-.49a1.605 1.605 0 0 1-.49-1.177V4.167c0-.459.163-.851.49-1.177.326-.327.718-.49 1.177-.49h11.666c.459 0 .851.163 1.177.49.327.326.49.718.49 1.177v11.666c0 .459-.163.851-.49 1.177-.326.327-.718.49-1.177.49H4.167Zm0-1.667h11.666V4.167H4.167v11.666Z"
  }))));
};
export default SvgIconBullet;